import React from 'react';
import Select from 'react-select';
import AddPlusIcon from '../assets/images_/Add_Plus.svg';

interface ClubsHeaderProps {
  title: string;
  description: string;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onAddClub?: () => void;
  addButtonText?: string;
  showAddButton?: boolean;
  showFilters?: boolean;
  locationFilter?: string;
  onLocationFilterChange?: (value: string) => void;
  locationFilterOptions?: Array<{value: string, label: string}>;
}

const ClubsHeader: React.FC<ClubsHeaderProps> = ({
  title,
  description,
  searchTerm,
  onSearchChange,
  onAddClub,
  addButtonText = "Add Club",
  showAddButton = true,
  showFilters = true,
  locationFilter,
  onLocationFilterChange,
  locationFilterOptions
}) => {
  return (
    <div className="teams-header-section mb-4" style={{ position: 'relative', zIndex: 10, padding: '0', background: 'transparent', margin: '0', backgroundColor: 'transparent' }}>
      {/* Single Row: Title/Description on Left, Filters and Add Button on Right */}
      <div className="d-flex justify-content-between align-items-center" style={{ position: 'relative', zIndex: 10, width: '100%', padding: '0', background: 'transparent', backgroundColor: 'transparent' }}>
        {/* Left: Clubs Title and Description */}
        <div className="teams-section-info" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', flex: '0 0 auto', background: 'transparent', backgroundColor: 'transparent' }}>
          <h4 className="section-title mb-2" style={{ fontSize: '20px', fontWeight: '600', color: '#495057', margin: '0 0 8px 0', lineHeight: '1.3' }}>{title}</h4>
          <p className="section-description mb-0" style={{ fontSize: '14px', color: '#6c757d', margin: '0', lineHeight: '1.4' }}>{description}</p>
        </div>
        
        {/* Right: Filters and Add Button */}
        <div className="filter-controls-right"
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '12px', 
            justifyContent: 'flex-end', 
            marginTop: '0',
            flexWrap: 'nowrap'
          }}
        >
          {showFilters && (
            <>
              <div className="inline-filters d-flex align-items-center gap-2">
                <div className="search-input-wrapper">
                  <input
                    type="text"
                    className="form-search"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                    style={{ width: '200px', paddingRight: '35px' }}
                  />
                  {searchTerm && (
                    <button
                      type="button"
                      className="clear-search-btn"
                      onClick={() => onSearchChange('')}
                      title="Clear search"
                    >
                      <i className="ri-close-line"></i>
                    </button>
                  )}
                </div>
                {locationFilterOptions && (
                  <div className="location-filter-wrapper">
                    <Select
                      value={locationFilterOptions.find(option => option.value === locationFilter)}
                      onChange={(selectedOption) => onLocationFilterChange?.(selectedOption?.value || '')}
                      options={locationFilterOptions}
                      placeholder="Filter by Location"
                      className="location-filter-select"
                      isClearable
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minWidth: '180px',
                          fontSize: '14px',
                          borderRadius: '8px',
                          border: '1px solid #d1d5db',
                          minHeight: '36px'
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          fontSize: '14px',
                          color: '#6b7280'
                        })
                      }}
                    />
                  </div>
                )}
              </div>
            </>
          )}
          
          {showAddButton && onAddClub && (
            <button
              className="btn btn-primary add-club-btn"
              onClick={onAddClub}
              style={{ 
                position: 'relative', 
                zIndex: 15,
                fontFamily: 'Inter, Helvetica Neue, Arial, sans-serif',
                fontWeight: 500,
                fontSize: '13px',
                lineHeight: '150%',
                letterSpacing: '0%',
                textAlign: 'center',
                minWidth: '107px',
                height: '36px',
                borderRadius: '10px',
                gap: '4px',
                paddingTop: '8px',
                paddingRight: '16px',
                paddingBottom: '8px',
                paddingLeft: '16px',
                background: '#2563eb',
                color: '#fff',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                transition: 'background 0.2s',
                whiteSpace: 'nowrap'
              }}
            >
              {addButtonText}
              <img src={AddPlusIcon} alt="Add" style={{ width: 20, height: 20, marginLeft: 4, display: 'inline-block', verticalAlign: 'middle' }} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClubsHeader; 